// Centralized Google Analytics (GA4) helpers
// Minimal wrapper so components don't touch window.gtag directly

export const isGAAvailable = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

export const trackEvent = (eventName, params = {}) => {
  if (!isGAAvailable()) return;
  try {
    window.gtag('event', eventName, params);
  } catch (e) {
    // Silently ignore in non-prod
  }
};

export const trackShare = (platform, layers) => {
  // GA4 recommended params for share
  trackEvent('share', {
    method: platform,
    content_type: 'layer_recommendation',
    value: layers,
  });
};

export const trackPageView = (path, title) => {
  if (!isGAAvailable()) return;
  try {
    window.gtag('event', 'page_view', {
      page_title: title || document.title,
      page_location: window.location.href,
      page_path: path || window.location.pathname,
    });
  } catch (e) {
    // no-op
  }
};
